var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Alert'),(_vm.isLoading)?_c('div',{staticClass:"route-loading-overlay"},[_vm._m(0)]):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"route-loading-spinner"},[_c('i',{staticClass:"fa fa-spinner fa-spin"})])
}]

export { render, staticRenderFns }